interface ConvexFilter {
  clauses: Array<{
    id: string;
    field: string;
    op: string;
    value: string;
  }>;
}

export const buildConvexDashboardUrl = (deviceId: string): string => {
  const filter: ConvexFilter = {
    clauses: [
      {
        id: "0",
        field: "_id",
        op: "eq",
        value: deviceId
      }
    ]
  };

  const jsonString = JSON.stringify(filter);
  const base64Encoded = btoa(jsonString);
  const urlEncoded = encodeURIComponent(base64Encoded);

  return `https://dashboard.convex.dev/t/kphone/kphone/hip-gazelle-676/data?table=devices&filters=${urlEncoded}`;
};
